const cpdPointStatus = {
  pending: 'Pending',
  approved: 'Approved',
  denied: 'Denied',
  notAttending: 'NotAttending',
  draft: 'Draft',
  registered: 'Registered',
  adminReview: 'AdminReview'
};

export default cpdPointStatus;



// WEBPACK FOOTER //
// ./src/constants/cpd-point-status.js